import {RequestHelper} from "../libs/request-helper";
import {SpinnerHelper} from '../libs/spinner-helper';
import {EventsBanner} from "./events";
import {RecommenderResponseDto} from "../dtos/recommender-response-dto";
import {RecommenderDto} from '../dtos/recommender-dto.js';

export class Recommender {
    protected static readonly REQUEST_URL = "/wp-content/themes/Theaterholding/json/recommender.php";

    private static readonly HOUSE_ID_OPG = "20";
    private static readonly HOUSE_ID_SSHG = "30";
    private static readonly HOUSE_ID_NEXL = "40";
    private static readonly HOUSE_ID_GSP = "50";

	protected static lastDate: Date|null;

	protected static async init(): Promise<void> {

		Recommender.lastDate = null;
		document.addEventListener('DOMContentLoaded', Recommender.onDocumentLoaded, false);
	}

    protected static async onDocumentLoaded() {
		SpinnerHelper.startSpinning();
        Recommender.loadData();
	}

	private static async loadData() {
		const response = await RequestHelper.getJsonAndSpin<RecommenderResponseDto>(Recommender.REQUEST_URL);
		Recommender.renderEvents(<RecommenderResponseDto>response.data);
		SpinnerHelper.stopSpinning();
		EventsBanner.init();
	}

	private static renderEvents(recommendationData: RecommenderResponseDto) {
		let recommendations = recommendationData.recommendations;

		for (var _i = 0; _i < recommendations.length; _i++) {
			var event = recommendations[_i];
			Recommender.renderEvent(event);
		}

        const eventsHeader = document.getElementById("eventHeader");
		eventsHeader.setAttribute("style", "display: inline-block;");
	}

	private static renderEvent(rec: RecommenderDto) {

		let houseInformation = Recommender.getHouseInformation(rec.haus);
		if(rec.haus === Recommender.HOUSE_ID_GSP && rec.ort) {
			// for the events from Grazer Spielstaetten the concrete event place should be displayed
			houseInformation.houseName = rec.ort;
		}

		let carouselContainer = document.getElementById("owl-container");

		//<div class="item">
		var newItemContainer = document.createElement("div");
		newItemContainer.classList.add("item");

		//<p></p>
		var newTimeAndLocationContainer = document.createElement("p");

		//<a></a>
		var locationContainer = document.createElement("a");
		locationContainer.classList.add("event-place");
		locationContainer.setAttribute("target", "_blank");
		locationContainer.setAttribute("tabindex", "-1");
		locationContainer.setAttribute("href", houseInformation.houseURL); //set link for house from data

		var locationTextNode = document.createTextNode(houseInformation.houseName); //set name of location
		locationContainer.appendChild(locationTextNode);
		locationContainer.appendChild(document.createElement('br'))

		//<span></span>
		var newDateContainer = document.createElement("span");
		var dateString = rec.beginDate + " / ";
		var dateTextNode = document.createTextNode(dateString); //set date of event - / 10.Okt /
		newDateContainer.appendChild(dateTextNode);

		//<span></span>
		var newTimeContainer = document.createElement("span");
		var timeTextNode = document.createTextNode(rec.beginTime); //set time of event - 11:00
		newTimeContainer.appendChild(timeTextNode);

		//<h3></h3>
		var newTitleContainer = document.createElement("h3");
		newTitleContainer.classList.add("fontBold");
		var newTitleLink = document.createElement("a");

		var eventUrl = (houseInformation.houseProductionURL && rec.terminId) ? new URL(houseInformation.houseProductionURL + rec.terminId) : null;
		newTitleLink.setAttribute("href", eventUrl ? eventUrl.href : "");
		newTitleLink.setAttribute("target", "_blank");

		var newtitleTextNode = document.createTextNode(rec.name); //set title of event
		newTitleLink.appendChild(newtitleTextNode);
		newTitleContainer.appendChild(newTitleLink);

		//<div>
		var newTicketContainer = document.createElement("div");
		newTicketContainer.classList.add("class", "link");

		let now = new Date();
		let ticketsAvailableFrom = rec.ticketsAb ? new Date(rec.ticketsAb) : now;

		if(rec.ticket && rec.geschlosseneVorstellung === '0' && ticketsAvailableFrom <= now) {
			//<a></a>
			var newTicketLink = document.createElement("a");
			newTicketLink.setAttribute("target", "_blank");
			newTicketLink.classList.add("fontBoldItalic");

			var ticketUrl = new URL(rec.ticket);
			newTicketLink.setAttribute("href", ticketUrl.href);

			var newticketsTextNode = document.createTextNode("tickets");
			newTicketLink.appendChild(newticketsTextNode);

			//</img>
			var ticketArrow = document.createElement("img")
			ticketArrow.src = "/wp-content/themes/Theaterholding/images/arrow-right.png"
			newTicketLink.appendChild(ticketArrow)
			//</div>
			newTicketContainer.appendChild(newTicketLink);
		}else if (rec.geschlosseneVorstellung === '0' && ticketsAvailableFrom > now) {
			//<span></span>
			let newInformationSpan = document.createElement('span');
			newInformationSpan.classList.add('fontBoldItalic');

			let newInformationText =  'Karten verfügbar ab ' + Recommender.buildDateString(ticketsAvailableFrom);
			let newInformationTextNode = document.createTextNode(newInformationText);
			newInformationSpan.appendChild(newInformationTextNode);

			//</div>
			newTicketContainer.appendChild(newInformationSpan);
		}else if (rec.geschlosseneVorstellung === '1') {
			//<span></span>
			let newInformationSpan = document.createElement('span');
			newInformationSpan.classList.add('fontBoldItalic');

			let newInformationText = 'Geschlossene Vorstellung';
			let newInformationTextNode = document.createTextNode(newInformationText);
			newInformationSpan.appendChild(newInformationTextNode);

			//</div>
			newTicketContainer.appendChild(newInformationSpan);
		}



		newTimeAndLocationContainer.appendChild(locationContainer);
		newTimeAndLocationContainer.appendChild(newDateContainer);
		newTimeAndLocationContainer.appendChild(newTimeContainer);

		newItemContainer.appendChild(newTimeAndLocationContainer);
		newItemContainer.appendChild(newTitleContainer);
		newItemContainer.appendChild(newTicketContainer);

		carouselContainer.appendChild(newItemContainer);
	}

	private static buildDateString(date: Date): string {
		return date.getDate() + '.' + (date.getMonth()+1) + '.' + date.getFullYear() + ' ' + date.getHours() + ':' + ('0' + date.getMinutes()).slice(-2);
	}

	private static getHouseInformation(houseId: string) {

		let houseInformation = new HouseInformation();

		switch (houseId) {
			case Recommender.HOUSE_ID_OPG:
				houseInformation.houseName = "Oper Graz";
				houseInformation.houseURL = "https://oper-graz.buehnen-graz.com/";
				break;
			case Recommender.HOUSE_ID_SSHG:
				houseInformation.houseName = "Schauspielhaus Graz";
				houseInformation.houseURL = "https://schauspielhaus-graz.buehnen-graz.com/";
				break;
			case Recommender.HOUSE_ID_NEXL:
				houseInformation.houseName = "Next Liberty";
				houseInformation.houseURL = "https://nextliberty.buehnen-graz.com/";
				break;
			case Recommender.HOUSE_ID_GSP:
				houseInformation.houseName = "Grazer Spielstätten";
				houseInformation.houseURL = "https://spielstaetten.buehnen-graz.com/"
				break;
		}

		if(houseInformation.houseURL){
			houseInformation.houseProductionURL = houseInformation.houseURL + 'vorstellung/';
		}

		return houseInformation;
	}

}

class HouseInformation {

	public houseURL = "";
	public houseProductionURL = "";
	public houseName = ""
}
